/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function LogoSecondary({ color = '#3ebeb0', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      css={{
        ...css`
          color: ${color};
          cursor: pointer;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <g clipPath="url(#clip0_1488_817)">
        <path
          d="M27.5182 16.4703C27.3744 17.9566 26.9009 19.2452 26.0976 20.3361C25.2943 21.427 24.2456 22.26 22.9514 22.8352C21.6573 23.4104 20.2186 23.698 18.6362 23.698C16.8858 23.698 15.2799 23.3323 13.8178 22.6016C12.3556 21.8708 11.1866 20.8034 10.3121 19.4015C9.43691 17.9988 9 16.3265 9 14.3853C9 12.4441 9.43691 10.7358 10.3128 9.33316C11.1873 7.93048 12.3563 6.85825 13.8185 6.11509C15.2806 5.37193 16.8865 5 18.6369 5C20.2193 5 21.6448 5.28759 22.9162 5.86276C24.1868 6.43793 25.2293 7.25922 26.0444 8.32591C26.8587 9.39261 27.3509 10.6695 27.5182 12.1558H24.39C23.9822 10.861 23.2577 9.83644 22.2145 9.08152C21.172 8.3266 19.9788 7.94915 18.6369 7.94915C17.5343 7.94915 16.5091 8.20079 15.5626 8.70406C14.6155 9.20734 13.8599 9.93253 13.2972 10.8796C12.7338 11.8267 12.4524 12.9957 12.4524 14.3853C12.4524 15.7748 12.7338 16.8726 13.2972 17.819C13.8599 18.7661 14.61 19.4858 15.5447 19.9766C16.4793 20.4682 17.5101 20.7136 18.6369 20.7136C20.1709 20.7136 21.4174 20.3423 22.3762 19.5992C23.3344 18.8567 24.0181 17.8135 24.426 16.471H27.5182V16.4703Z"
          fill="currentColor"
        />
        <path
          d="M27.5671 26.8967H9.52246V30H27.5671V26.8967Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1488_817">
          <rect
            width="18.5673"
            height="25"
            fill="white"
            transform="translate(9 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

LogoSecondary.propTypes = {
  css: PropTypes.instanceOf(css),
};
